// Lightweight, GDPR/UAE-PDPL-friendly tracking helpers.
// Both providers are disabled by default — they only initialise once an ID is set
// in /app/frontend/.env (REACT_APP_GA4_ID + REACT_APP_META_PIXEL_ID).
//
// Designed for the GCC paid-traffic landing page /sa: tracks page view + 4 lead-type
// pre-qualifier choices + form submissions. Fires custom events on each step so
// Meta + Google can optimise toward Principal-tier conversions specifically.

const GA4_ID = process.env.REACT_APP_GA4_ID || "";
const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "";

let initialised = false;

export function initTracking() {
  if (initialised || typeof window === "undefined") return;
  initialised = true;

  // ---- Google Analytics 4 ----
  if (GA4_ID) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    // eslint-disable-next-line prefer-rest-params
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA4_ID, { anonymize_ip: true });
  }

  // ---- Meta (Facebook) Pixel ----
  if (META_PIXEL_ID) {
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
      t = b.createElement(e); t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    window.fbq("init", META_PIXEL_ID);
    window.fbq("track", "PageView");
  }
}

export function trackEvent(name, params = {}) {
  if (typeof window === "undefined") return;
  try {
    if (GA4_ID && window.gtag) window.gtag("event", name, params);
    if (META_PIXEL_ID && window.fbq) {
      // Meta uses a fixed taxonomy; map our names to its standard events when possible
      const fbName =
        {
          lead_qualifier_selected: "Lead",
          form_submit: "Lead",
          form_success: "CompleteRegistration",
          whatsapp_click: "Contact",
        }[name] || "trackCustom";
      if (fbName === "trackCustom") window.fbq("trackCustom", name, params);
      else window.fbq("track", fbName, params);
    }
  } catch (_) { /* swallow */ }
}

export function trackPageView(path) {
  if (typeof window === "undefined") return;
  if (GA4_ID && window.gtag) window.gtag("event", "page_view", { page_path: path });
  if (META_PIXEL_ID && window.fbq) window.fbq("track", "PageView");
}

export const isTrackingEnabled = !!(GA4_ID || META_PIXEL_ID);
